/* ==========================================================================
   VYNE — Theme scripts (v3 — dynamic hero bg + drawer + reveal)
   ========================================================================== */
(function () {
  'use strict';

  // Safety net: if anything below errors, reveals still show.
  // We schedule a hard fallback that runs no matter what.
  setTimeout(function () {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }, 2500);
    const nav = document.querySelector('[data-vyne-nav]');

  // Grab the nav up front. applyFinish() in the hero block below calls
  // onScroll(), which reads `nav` — if `nav` were still a const in its temporal
  // dead zone, that call throws and halts the whole script, which is exactly
  // what stopped the hamburger/drawer from binding on the home page.

  /* ---------- HERO FINISH SWITCHER ---------- */
  const hero = document.querySelector('[data-vyne-hero]');
  if (hero) {
    let finishes = [];
    try { finishes = JSON.parse(hero.getAttribute('data-finishes') || '[]'); } catch (e) { finishes = []; }

    if (finishes.length) {
      const ledeEyebrow = hero.querySelector('[data-lede-eyebrow]');
      const ledeTitle   = hero.querySelector('[data-lede-title]');
      const ledeSpecs   = hero.querySelector('[data-lede-specs]');
      const finishName  = hero.querySelector('[data-finish-name]');
      const finishSub   = hero.querySelector('[data-finish-sub]');
      const heroIx      = hero.querySelector('[data-hero-ix]');
      const ctaShop     = hero.querySelector('[data-cta-shop]');
      const ghostWord   = hero.querySelector('[data-ghost-word]');
      const prevBtn     = hero.querySelector('[data-prev]');
      const nextBtn     = hero.querySelector('[data-next]');
      const swatches    = hero.querySelectorAll('[data-selector] .sw');
      const bgs         = hero.querySelectorAll('.bg');

      let idx = 0;

      // Letter count alone can't size the word: wide letters (MOCHA) still ran past
      // the edges. Shrink it until it fits 94% of the hero's width.
      function fitGhost() {
        if (!ghostWord) return;
        ghostWord.style.fontSize = '';
        const max = hero.clientWidth * 0.94, w = ghostWord.scrollWidth;
        if (w > max) ghostWord.style.fontSize = (parseFloat(getComputedStyle(ghostWord).fontSize) * max / w).toFixed(1) + 'px';
      }
      window.addEventListener('resize', fitGhost);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitGhost);

      function applyFinish(i) {
        idx = ((i % finishes.length) + finishes.length) % finishes.length;
        const f = finishes[idx];

        bgs.forEach(el => el.classList.toggle('on', el.dataset.key === f.k));
        swatches.forEach(el => el.classList.toggle('on', el.dataset.k === f.k));

        if (ledeEyebrow) ledeEyebrow.textContent = f.eyebrow || '';
        if (ledeTitle)   ledeTitle.innerHTML    = f.title   || '';
        if (ledeSpecs)   ledeSpecs.textContent  = f.specs   || '';
        if (finishName)  finishName.innerHTML   = (f.name || '') + ' <em>·</em>';
        if (finishSub)   finishSub.textContent  = f.sub     || '';
        if (heroIx)      heroIx.textContent     = String(idx + 1).padStart(2,'0') + ' / ' + String(finishes.length).padStart(2,'0') + ' — THE COLLECTION';
        if (ctaShop) {
          // Long names keep their first word so the two CTAs stay on one line
          // (Carbon Fiber -> Carbon); short two-word names stay whole (Jet Black).
          var shortName = (f.name || '').length > 10 ? (f.name || '').split(' ')[0] : (f.name || '');
          ctaShop.textContent = 'Shop ' + shortName + ' →';
          if (f.url) ctaShop.href = f.url;
        }
        if (ghostWord) {
          var ghostText = f.ghost || '';
          ghostWord.textContent = ghostText;
          // Long names (GRAPHITE, MIDNIGHT) run off the viewport at a fixed
          // size, so the type scales down with the letter count.
          ghostWord.style.setProperty('--ghost-len', ghostText.length || 1);
          fitGhost();
        }
        hero.dataset.finish = f.k; // per-finish tweaks in CSS (Jet Black's word sits higher)

        hero.classList.toggle('is-light', !!f.light);
        if (f.bg) {
          document.documentElement.style.setProperty('--hero-bg', f.bg);
        }
        if (typeof onScroll === 'function') onScroll();
      }

      swatches.forEach(btn => {
        btn.addEventListener('click', () => {
          const i = finishes.findIndex(f => f.k === btn.dataset.k);
          if (i >= 0) applyFinish(i);
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', () => applyFinish(idx - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => applyFinish(idx + 1));

      applyFinish(0);
    }
  }

  /* ---------- NAV STATE ---------- */
  // True when the first solid background under the nav's bottom edge is light.
  function lightUnderNav() {
    const r = nav.getBoundingClientRect();
    const stack = document.elementsFromPoint(window.innerWidth / 2, Math.max(1, r.bottom - 4));
    for (const el of stack) {
      if (nav.contains(el)) continue;
      const m = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
      if (!m || (m.length > 3 && +m[3] < 0.5)) continue;
      const lum = (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255;
      return lum > 0.55;
    }
    return false;
  }
  function onScroll() {
    if (!nav) return;
    const y = window.scrollY;
    const lightSelectors = ['.vyne-col', '.vyne-detail', '.vyne-mat'];
    let onLight = false;
    lightSelectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.top <= 70 && r.bottom >= 70) onLight = true;
      });
    });
    // also light if hero (when visible at top) is in is-light mode
    if (hero && y < window.innerHeight - 90 && hero.classList.contains('is-light')) onLight = true;
    // Any other page or section: light PDPs (Sage, Pinky, Artic, White, Dune), FAQ,
    // cart and policies sit on cream/pastel right under the white nav.
    if (!onLight && lightUnderNav()) onLight = true;
    // Force .solid whenever we're over a light section so the dark frost
    // bg always paints (otherwise the header would be invisible white-on-cream).
    // Also kick in earlier (y > 8 instead of 30) so there's no flash of
    // transparent-on-cream when transitioning from hero into Collection.
    nav.classList.toggle('solid', y > 8 || onLight);
    nav.classList.toggle('light', onLight);
  }
  let navTick = false;
  window.addEventListener('scroll', () => {
    if (navTick) return;
    navTick = true;
    requestAnimationFrame(() => { navTick = false; onScroll(); });
  }, { passive: true });
  // Set the bar without the 1.1s fade. This script can run before the section
  // stylesheets land (cold cache), when the page under the nav still reads dark,
  // so it runs again once styles and images have loaded.
  function settleNav() {
    if (!nav) return;
    nav.style.transition = 'none';
    onScroll();
    void nav.offsetHeight;
    requestAnimationFrame(() => { nav.style.transition = ''; });
  }
  settleNav();
  window.addEventListener('load', settleNav);
  window.addEventListener('pageshow', settleNav);
  // expose to applyFinish closure above
  window.__vyneOnScroll = onScroll;

  /* ---------- DRAWER ---------- */
  const drawer = document.querySelector('[data-drawer]');
  const drawerToggle = document.querySelector('[data-drawer-toggle]');
  const drawerClosers = document.querySelectorAll('[data-drawer-close]');
  const htmlEl = document.documentElement;

  function setDrawerOpen(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (drawerToggle) drawerToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    htmlEl.classList.toggle('vyne-drawer-open', open);
  }

  if (drawerToggle) {
    drawerToggle.addEventListener('click', () => {
      setDrawerOpen(!drawer.classList.contains('open'));
    });
  }
  drawerClosers.forEach(el => el.addEventListener('click', () => setDrawerOpen(false)));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) setDrawerOpen(false);
  });

  /* ---------- REVEAL ON SCROLL ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('in'));
  }

  /* ---------- KLAVIYO VIP POPUP: CONSENT BOX STARTS CHECKED ---------- */
  // Klaviyo has no "checked by default" option, so tick it when the popup opens.
  // The visitor can still untick it before submitting.
  const VIP_FORM = 'TmGbWS';
  function checkVipConsent(tries) {
    const boxes = document.querySelectorAll(`form[data-testid="klaviyo-form-${VIP_FORM}"] .klaviyo-checkboxes input[type="checkbox"]`);
    if (!boxes.length) {
      if (tries > 0) setTimeout(() => checkVipConsent(tries - 1), 250);
      return;
    }
    boxes.forEach(box => {
      if (box.checked || box.dataset.vyneAuto) return;
      box.dataset.vyneAuto = '1';
      box.click();
    });
  }
  window.addEventListener('klaviyoForms', (e) => {
    const d = e.detail || {};
    if (d.formId === VIP_FORM && (d.type === 'open' || d.type === 'embedOpen')) checkVipConsent(20);
  });

  /* ---------- PRODUCT GALLERIES: SWIPE TO THE NEXT PHOTO ---------- */
  // The galleries no longer rotate on their own (Arturo, 2026-10-21). A sideways swipe on the
  // big photo taps the next or previous visible thumb, so each page's own thumb handler (photo,
  // colour, model) does the rest. Hidden thumbs (other models or colours) are skipped.
  document.querySelectorAll('[data-stage]').forEach(stage => {
    const scope = stage.closest('[class*="-gallery"]') || stage.parentElement;
    const thumbsBox = scope && scope.querySelector('[data-thumbs]');
    if (!thumbsBox) return;
    let x0 = null, y0 = 0;
    stage.addEventListener('touchstart', e => { const t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    stage.addEventListener('touchend', e => {
      if (x0 === null) return;
      const t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      const thumbs = [...thumbsBox.querySelectorAll('.t')].filter(el => !el.hidden && el.offsetParent !== null);
      if (thumbs.length < 2) return;
      const at = Math.max(0, thumbs.findIndex(el => el.classList.contains('on')));
      thumbs[(at + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length].click();
    }, { passive: true });
  });

  /* ---------- INBOX CHAT: OPENED FROM "CHAT" IN THE TOP BAR ---------- */
  // The floating chat button is hidden: ::part(activator) in vyne.css, plus its invisible 94x50
  // box inside the chat's open shadow root (that box used to catch taps on the bottom buy
  // buttons). "Chat" in the top bar opens the chat with the element's own show(); before the
  // chat has loaded, or without the Inbox app, the link just goes to the Contact page.
  function hideChatLauncher(tries) {
    const chat = document.querySelector('shopify-chat');
    const root = chat && chat.shadowRoot;
    if (!root || !root.querySelector('.activator-nudge')) {
      if (tries > 0) setTimeout(() => hideChatLauncher(tries - 1), 500);
      return;
    }
    if (root.querySelector('style[data-vyne]')) return;
    const st = document.createElement('style');
    st.setAttribute('data-vyne', '');
    st.textContent = '.activator-nudge{display:none!important}';
    root.appendChild(st);
  }
  hideChatLauncher(120);
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-chat-open]');
    const chat = btn && document.querySelector('shopify-chat');
    if (!chat || typeof chat.show !== 'function') return;
    e.preventDefault();
    chat.show();
  });

  // While a product page's sticky "Add to bag" bar is up, html.vyne-lift moves the Klaviyo
  // teaser above it by the bar's height (--vyne-lift, see vyne.css).

  const stickyBars = document.querySelectorAll('[data-stickybar]');
  if (stickyBars.length) {
    const syncLift = () => {
      const up = [...stickyBars].find(b => b.classList.contains('show'));
      if (up) document.documentElement.style.setProperty('--vyne-lift', (up.offsetHeight + 10) + 'px');
      document.documentElement.classList.toggle('vyne-lift', !!up);
    };
    const mo = new MutationObserver(syncLift);
    stickyBars.forEach(b => mo.observe(b, { attributes: true, attributeFilter: ['class'] }));
    syncLift();
  }
})();
